module.exports = __webpack_public_path__ + "img/preview.e3d9f605.jpg";